import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Шрифты загружаются локально для устранения блокировки отрисовки (улучшение LCP)
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import './index.css'
import App from './App.tsx'
import { SiteProvider } from './context/SiteContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SiteProvider>
      <App />
    </SiteProvider>
  </StrictMode>,
)
